import React, { useEffect } from "react";
import "./Inner_Calm.css";
import Common_Title_1 from "../../common/common_components/common_title_1/Common_Title_1";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { AllMeditaion } from "../../../features/admin/common/Slice";
import { IDS } from "../../../utils/IDS";
import { decodeId, encodeId } from "../../../utils/common";

const Inner_Calm = () => {
  const data = [
    {
      label: "Meditation",
      img: "/assets/images/home/inner_calm/img1.png",
      link: "/inner-calm-meditation"
    },
    {
      label: "Maun Sadhana",
      img: "/assets/images/home/inner_calm/img2.png",
      link: "/inner-calm-meditation"
    },
    {
      label: "Meditation",
      img: "/assets/images/home/inner_calm/img3.png",
      link: "/inner-calm-meditation"
    },
    {
      label: "Yoga",
      img: "/assets/images/home/inner_calm/img1.png",
      link: "/inner-calm-meditation"
    },
  ];

  const navigate = useNavigate()

  const dispatch = useDispatch();
  const meditations = useSelector((state) => state.common.meditations);

  useEffect(() => {
    dispatch(AllMeditaion());
  }, [dispatch])



  return (
    <section className="Inner_Calm">
      <div className="container">
        <Common_Title_1
          titleText="INNER CALM"
          subText="Today's Path to Inner Peace"
        />

        <div className="content_div">
          <div className="row">
            {meditations?.map((item) => {
              return (
                <div className="col-lg-3 col-6">
                  <div className="calm_card" onClick={() => { navigate(`/inner-calm-meditation/${encodeId(item?.meditation_id)}`) }}>
                    <div className="img_holder">
                      <img src={IDS.IMG_URL + item?.Meditation?.image} className="inner_img" />
                    </div>
                    <p className="label_text">{item?.name}</p>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Inner_Calm;
